import React from 'react'

const SliderBasicTitle = ({title}) => {
    if(!title) {
        return ''
    }
    
    return <h2 className={'headline title-xlarge'} style={{whiteSpace: "pre-line"}} dangerouslySetInnerHTML={{ __html: title}}></h2>
}  

export default SliderBasicTitle